import { Component, AfterContentChecked, OnInit, Input, Compiler, NgModule } from '@angular/core';
import { ICellRendererAngularComp } from "ag-grid-angular";

@Component({
    selector: 'app-button',
    template: `
      <button type="button" (click)="onClick($event)"> <span class="glyphicon glyphicon-eye-open"></span></button>
      `
  })
  
  export class ButtonRendererComponent implements ICellRendererAngularComp {
  
    params;
    label: string;
  
    agInit(params): void {
      this.params = params;
      this.label = this.params.label || null;
    }
  
    refresh(params?: any): boolean {
      return true;
    }
  
    onClick($event) {
      if (this.params.onClick instanceof Function) {
        // put anything into params u want pass into parents component
        const params = {
          event: $event,
          rowData: this.params.node.data
          // ...something
        }
        this.params.onClick(this.params);
  
      }
    }
  }
  
  
  
  


// WEBPACK FOOTER //
// ./src/app/cs/views/app-button/app-button.component.ts